var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoinF(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4167 10.5416V13.625C15.4167 16.225 12.9917 18.3333 10 18.3333C7.00834 18.3333 4.58334 16.225 4.58334 13.625V10.5416C4.58334 13.1416 7.00834 15 10 15C12.9917 15 15.4167 13.1416 15.4167 10.5416Z",
    stroke: "#919191",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4167 6.37496C15.4167 7.13329 15.2083 7.83329 14.8417 8.43329C13.95 9.89996 12.1167 10.8333 10 10.8333C7.88334 10.8333 6.05001 9.89996 5.15835 8.43329C4.79168 7.83329 4.58334 7.13329 4.58334 6.37496C4.58334 5.07496 5.19167 3.89996 6.16667 3.04996C7.15001 2.19163 8.50001 1.66663 10 1.66663C11.5 1.66663 12.85 2.19163 13.8333 3.04163C14.8083 3.89996 15.4167 5.07496 15.4167 6.37496Z",
    stroke: "#919191",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4167 6.37496V10.5416C15.4167 13.1416 12.9917 15 10 15C7.00834 15 4.58334 13.1416 4.58334 10.5416V6.37496C4.58334 3.77496 7.00834 1.66663 10 1.66663C11.5 1.66663 12.85 2.19163 13.8333 3.04163C14.8083 3.89996 15.4167 5.07496 15.4167 6.37496Z",
    stroke: "#919191",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinF);
export default __webpack_public_path__ + "static/media/coin-f.c171014203e426628d8ce7ea233b0558.svg";
export { ForwardRef as ReactComponent };